import React from "react";
import styles from "./styles.module.scss";

const TagOptions = ({ tags, setTags, availableTags }) => {
  function toCapitalize(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
  return (
    <fieldset className={styles.optionsContainer}>
      <legend className={styles.title}>Select tags</legend>
      <div className={styles.tagWrapper}>
        {availableTags.map((tag) => (
          <label key={tag} className={styles.singleTag}>
            <input
              type="checkbox"
              checked={tags.includes(tag)}
              value={tag}
              onChange={(e) => {
                if (e.target.checked) {
                  setTags([...tags, tag]);
                } else {
                  setTags(tags.filter((t) => t !== tag));
                }
              }}
            />
            {toCapitalize(tag)}
          </label>
        ))}
      </div>
    </fieldset>
  );
};

export default TagOptions;
